import "./index.css";

import { ApolloClient, ApolloProvider } from "@apollo/client";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import type { Theme } from "./components";
import { ThemedChakraProvider, TrackPages } from "./components";
import type { ColorModeManager } from "./theme/colorModeManager";

interface Props {
  apolloClient: ApolloClient<any>;
  children: React.ReactNode;
  basename?: string;
  themeOverride?: Theme;
  interThemeOverride?: Theme;
  colorModeManager?: ColorModeManager;
}

const App: React.FC<Props> = ({
  apolloClient,
  basename,
  children,
  themeOverride,
  interThemeOverride,
  colorModeManager,
}) => {
  return (
    <ApolloProvider client={apolloClient}>
      <Router basename={basename}>
        <TrackPages />
        <ThemedChakraProvider
          themeOverride={themeOverride}
          interThemeOverride={interThemeOverride}
          colorModeManager={colorModeManager}
        >
          {children}
        </ThemedChakraProvider>
      </Router>
    </ApolloProvider>
  );
};

export default App;
